import React, { useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import {
  Autocomplete,
  AutocompleteHighlighter,
} from '../../../../../Inputs/AutocompleteInput';
import { formatUserFullName } from '@uplift/utils';
import { usePatients } from './PatientsAutocomplete.hooks';
import { useCurrentuser } from '@uplift/contexts';


type _patientResponse = ReturnType<typeof usePatients>[0];
const patientSearchFilter = (options: _patientResponse[], { inputValue }: { inputValue: string }) => {
  const terms = inputValue.trim().toLowerCase().split(' ');

  return options.filter(opt =>
    terms.every(term =>
      opt.firstName?.toLowerCase()?.includes(term)
      || opt.lastName?.toLowerCase()?.includes(term)
      || opt.preferredName?.toLowerCase()?.includes(term)
      || opt.email?.toLowerCase()?.includes(term)
    )
  );
};


const EmailHighlighter = withStyles(AutocompleteHighlighter, {
  highlight: {
    fontWeight: 500,
  }
});


export type PatientSearchAutocompleteProps = {
  name: string;
  label?: string;
  autoFocus?: boolean;
  placeholder?: string;
};


export const PatientSearchAutocomplete: React.VFC<PatientSearchAutocompleteProps> = (props) => {
  const me = useCurrentuser();
  const patients = usePatients(me.id);
  const handleRenderOption = useCallback((option, state) => (
    <Box display="flex" flexDirection="column">
      <Typography>
        <AutocompleteHighlighter text={formatUserFullName({ ...option, preferredFirstName: option.preferredName })} highlight={state.inputValue} />
      </Typography>
      <Typography variant="body2" color="textSecondary">
        <EmailHighlighter text={option.email} highlight={state.inputValue} />
      </Typography>
    </Box>
  ), []);

  return (
    <Box position="relative" width="100%">
      <Autocomplete
        {...props}
        fullWidth
        disablePortal
        options={patients || []}
        getOptionLabel={option => formatUserFullName({ ...option, preferredFirstName: option.preferredName, fallback: option.email })}
        renderOption={handleRenderOption}
        filterOptions={patientSearchFilter}
      />
    </Box>
  );
};
